<template>
  <main class="pb-[79px] md:pb-5">
    <HomeSlider
      v-if="!slidesInitialized || slidesDesktop?.length || slidesMobile?.length"
      :desktop="slidesDesktop"
      :mobile="slidesMobile"
      :loading="!slidesInitialized"
      class="mb-6 md:mb-9"
    />
    <NavigateCategoriesList v-if="isMdAndDown" class="mb-7" />
    <div v-if="showPageCompilations" class="mb-2 flex w-full flex-col gap-2">
      <CompilationsForPage :value="pageCompilations" :loading="!pageCompilationsInitialized" />
    </div>

    <section class="mb-2 py-2 lg:py-0">
      <CompilationWidget
        :value="freeEvents"
        hide-header
        :loading="!homeFreeEventsInitialized"
        :grid="freeEventsGrid"
        type="tiles"
      >
        <template #empty><span /></template>
      </CompilationWidget>
    </section>

    <UiContainer class="!sticky bottom-20 z-30 flex justify-end md:bottom-10">
      <UiScrollUpButton />
    </UiContainer>
  </main>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed, defineAsyncComponent, onMounted } from 'vue'
import { CompilationsForPage } from '@/3_widgets/Compilation'
import { HomeSlider } from '@/3_widgets/Home'
import { NavigateCategoriesList } from '@/4_features/Category'
import { useCompilation } from '@/5_entities/Compilation'
import { useReloadOnConfigurationUpdate } from '@/5_entities/Configuration'
import { useHome } from '@/5_entities/Home'
import { SlideLocation, useSlide } from '@/5_entities/Slide'
import { useBreakpoint } from '@/6_shared/lib'
import { UiContainer, UiScrollUpButton } from '@/6_shared/ui'

const CompilationWidget = defineAsyncComponent(async () => {
  const { CompilationWidget } = await import('@/3_widgets/Compilation')

  return CompilationWidget
})

const {
  sm: [_isSmAndUp, isSmAndDown],
  lg: [isLgAndUp],
  md: [isMdAndUp, isMdAndDown]
} = useBreakpoint()

const { getFreeEvents, getHomePageCompilations, cleanFreeEvents } = useHome()
const { freeEvents, homeFreeEventsInitialized } = storeToRefs(useHome())
const { pageCompilations, pageCompilationsInitialized, showPageCompilations } =
  storeToRefs(useCompilation())

//slides
const { getSlides } = useSlide()
const { slidesDesktop, slidesMobile, slidesInitialized } = storeToRefs(useSlide())

const initPage = async () => {
  cleanFreeEvents()
  await getSlides(SlideLocation.homepage)
  await getHomePageCompilations(isMdAndUp.value ? 9 : 10, isLgAndUp.value ? 3 : 5)

  getFreeEvents()
}

useReloadOnConfigurationUpdate(() => initPage())
onMounted(async () => {
  await initPage()
})

//free events
const freeEventsGrid = computed(() => {
  if (isSmAndDown.value) return 1
  if (isMdAndDown.value) return 2

  return isLgAndUp.value ? 4 : 3
})
</script>
